import { render, staticRenderFns } from "./OrderInstallAdd.vue?vue&type=template&id=feb518cc&"
import script from "./OrderInstallAdd.vue?vue&type=script&lang=ts&"
export * from "./OrderInstallAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports